import { Injectable } from '@angular/core';
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LocalStorageService } from './services/local-storage/local-storage.service';
import { StateService } from './services/state/state.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable()
export class AuthExpiredInterceptor implements HttpInterceptor {
  constructor(
    private localStorageService: LocalStorageService,
    private stateService: StateService,
    private message: NzMessageService,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((err: any) => {
        if (err instanceof HttpErrorResponse && err.status === 401) {
          const hadToken = !!this.localStorageService.getAccessToken();
          const isWebView = this.localStorageService.getWebview();
          if (hadToken && !isWebView) {
            this.localStorageService.setAccessToken('');
            this.localStorageService.setRefreshToken('');
            this.stateService.isLoggedIn.set(false);
            this.message.warning('Войдите в аккаунт');
          }
        }
        return throwError(() => err);
      })
    );
  }
}
